import axiosInstance from '../axiosInterceptor/axiosInstance'

const getPrivacyStatus = async () => {
  const url = `/events/privacy-status`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getPrivacyStatus
